var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DA1E27",
    fillRule: "nonzero",
    d: "M14.372 15.72L11 12.349 7.628 15.72c-.24.24-.592.335-.92.247-.33-.088-.587-.345-.675-.674-.088-.33.006-.68.247-.921l3.371-3.373L6.28 7.627c-.24-.24-.335-.592-.247-.92.088-.33.345-.587.674-.675.33-.088.68.006.921.247L11 9.65l3.372-3.371c.24-.24.592-.335.92-.247.33.088.587.345.675.674.088.33-.006.68-.247.921l-3.371 3.372 3.371 3.372c.24.24.335.592.247.92-.088.33-.345.587-.674.675-.33.088-.68-.006-.921-.247v.001z",
    transform: "translate(-1085 -506) translate(352 389) translate(734 118)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#DA1E27",
    strokeWidth: 2,
    transform: "translate(-1085 -506) translate(352 389) translate(734 118)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.2a1e403d7b6d0a264d24d114d8d119e7.svg";
export { ForwardRef as ReactComponent };